'use client';

import { AlertTriangle, ExternalLink } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils';

interface LinkPreviewErrorStateProperties {
  className?: string;
  message?: string;
  onRetry?: () => void;
  url: string;
}

export function LinkPreviewErrorState({ url, onRetry, className, message }: LinkPreviewErrorStateProperties) {
  return (
    <div
      className={cn(
        'mt-3 flex flex-col gap-3 rounded-2xl border border-border/60 bg-card/95 p-5 text-sm text-muted-foreground',
        className
      )}
      role="alert"
    >
      <div className="flex items-center gap-2">
        <AlertTriangle className="h-4 w-4 text-amber-500" aria-hidden="true" />
        <span>{message ?? 'We had trouble loading the link preview.'}</span>
      </div>
      <div className="flex flex-wrap gap-2">
        <Button variant="ghost" size="sm" asChild>
          <a href={url} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2">
            Open link
            <ExternalLink className="h-3.5 w-3.5" aria-hidden="true" />
          </a>
        </Button>
        {onRetry ? (
          <Button variant="outline" size="sm" onClick={onRetry}>
            Try again
          </Button>
        ) : null}
      </div>
    </div>
  );
}
